import "@arco-design/web-react/es/ConfigProvider/style";
import _ConfigProvider from "@arco-design/web-react/es/ConfigProvider";
import './style/global.less';
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import zhCN from '@arco-design/web-react/es/locale/zh-CN';
import enUS from '@arco-design/web-react/es/locale/en-US';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import rootReducer from './store';
import PageLayout from './layout';
import { GlobalContext } from './context';
import changeTheme from './utils/changeTheme';
import useStorage from './utils/useStorage';
import './utils/http';
window.staticHost = 'www.fjpca.com';
const store = createStore(rootReducer);
function Index() {
  const [lang, setLang] = useStorage('arco-lang', 'zh-CN');
  const [theme, setTheme] = useStorage('arco-theme', 'light');
  function getArcoLocale() {
    switch (lang) {
      case 'zh-CN':
        return zhCN;
      case 'en-US':
        return enUS;
      default:
        return zhCN;
    }
  }
  useEffect(() => {
    changeTheme(theme);
  }, [theme]);
  const contextValue = {
    lang,
    setLang,
    theme,
    setTheme
  };
  return /*#__PURE__*/React.createElement(BrowserRouter, null, /*#__PURE__*/React.createElement(_ConfigProvider, {
    componentConfig: {
      Card: {
        bordered: false
      },
      List: {
        bordered: false
      },
      Table: {
        border: false
      }
    }
  }, /*#__PURE__*/React.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React.createElement(GlobalContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    path: "/",
    component: PageLayout
  }))))));
}
ReactDOM.render( /*#__PURE__*/React.createElement(Index, null), document.getElementById('root'));